// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import StripeCustomer from "./stripe-customer.js"
import StripePaymentMethod from "./stripe-payment-method.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "next_action_redirect_to_url": {
      "column": null,
      "name": "next_action_redirect_to_url",
      "selected_by_default": null,
      "translated": null
    },
    "status": {
      "column": {
        "default": null,
        "name": "status",
        "null": true,
        "type": "string"
      },
      "name": "status",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "StripePaymentIntent",
  "collectionKey": "stripe_payment_intents",
  "collectionName": "stripe_payment_intents",
  "i18nKey": "stripe_payment_intent",
  "camelizedLower": "stripePaymentIntent",
  "name": "StripePaymentIntent",
  "nameDasherized": "stripe-payment-intent",
  "pluralName": "stripe_payment_intents",
  "ransackable_associations": [
    {
      "className": "ActiveRecordAuditable::Audit",
      "collectionName": "audits",
      "foreignKey": "auditable_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "Audit",
      "through": null
    },
    {
      "className": "ActiveRecordAuditable::Audit",
      "collectionName": "audits",
      "foreignKey": "auditable_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "Audit",
      "through": null
    },
    {
      "className": "StripeCharge",
      "collectionName": "stripe_charges",
      "foreignKey": "payment_intent",
      "name": "stripe_charges",
      "macro": "has_many",
      "resource_name": "StripeCharge",
      "through": null
    },
    {
      "className": "StripeCustomer",
      "collectionName": "stripe_customers",
      "foreignKey": "customer",
      "name": "stripe_customer",
      "macro": "belongs_to",
      "resource_name": "StripeCustomer",
      "through": null
    },
    {
      "className": "StripeCharge",
      "collectionName": "stripe_charges",
      "foreignKey": "latest_charge",
      "name": "stripe_latest_charge",
      "macro": "belongs_to",
      "resource_name": "StripeCharge",
      "through": null
    },
    {
      "className": "StripePaymentMethod",
      "collectionName": "stripe_payment_methods",
      "foreignKey": "payment_method",
      "name": "stripe_payment_method",
      "macro": "belongs_to",
      "resource_name": "StripePaymentMethod",
      "through": null
    },
    {
      "className": "StripeRefund",
      "collectionName": null,
      "foreignKey": "payment_intent",
      "name": "stripe_refunds",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "amount",
      "column": {
        "default": null,
        "name": "amount",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "amount_capturable",
      "column": {
        "default": null,
        "name": "amount_capturable",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "amount_details",
      "column": {
        "default": null,
        "name": "amount_details",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "amount_received",
      "column": {
        "default": null,
        "name": "amount_received",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "application",
      "column": {
        "default": null,
        "name": "application",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "application_fee_amount",
      "column": {
        "default": null,
        "name": "application_fee_amount",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "automatic_payment_methods",
      "column": {
        "default": null,
        "name": "automatic_payment_methods",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "canceled_at",
      "column": {
        "default": null,
        "name": "canceled_at",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "cancellation_reason",
      "column": {
        "default": null,
        "name": "cancellation_reason",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "capture_method",
      "column": {
        "default": null,
        "name": "capture_method",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "client_secret",
      "column": {
        "default": null,
        "name": "client_secret",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "confirmation_method",
      "column": {
        "default": null,
        "name": "confirmation_method",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "created",
      "column": {
        "default": null,
        "name": "created",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "currency",
      "column": {
        "default": null,
        "name": "currency",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "customer",
      "column": {
        "default": null,
        "name": "customer",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "description",
      "column": {
        "default": null,
        "name": "description",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "invoice",
      "column": {
        "default": null,
        "name": "invoice",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "last_payment_error",
      "column": {
        "default": null,
        "name": "last_payment_error",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "latest_charge",
      "column": {
        "default": null,
        "name": "latest_charge",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "livemode",
      "column": {
        "default": null,
        "name": "livemode",
        "null": true,
        "type": "boolean"
      }
    },
    {
      "name": "metadata",
      "column": {
        "default": null,
        "name": "metadata",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "next_action",
      "column": {
        "default": null,
        "name": "next_action",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "on_behalf_of",
      "column": {
        "default": null,
        "name": "on_behalf_of",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "payment_method",
      "column": {
        "default": null,
        "name": "payment_method",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "payment_method_options",
      "column": {
        "default": null,
        "name": "payment_method_options",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "payment_method_types",
      "column": {
        "default": null,
        "name": "payment_method_types",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "processing",
      "column": {
        "default": null,
        "name": "processing",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "receipt_email",
      "column": {
        "default": null,
        "name": "receipt_email",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "review",
      "column": {
        "default": null,
        "name": "review",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "setup_future_usage",
      "column": {
        "default": null,
        "name": "setup_future_usage",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "shipping",
      "column": {
        "default": null,
        "name": "shipping",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "statement_descriptor",
      "column": {
        "default": null,
        "name": "statement_descriptor",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "statement_descriptor_suffix",
      "column": {
        "default": null,
        "name": "statement_descriptor_suffix",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "status",
      "column": {
        "default": null,
        "name": "status",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "stripe_id",
      "column": {
        "default": null,
        "name": "stripe_id",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "transfer_data",
      "column": {
        "default": null,
        "name": "transfer_data",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "transfer_group",
      "column": {
        "default": null,
        "name": "transfer_group",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "StripeCustomer",
      "collectionName": "stripe_customers",
      "foreignKey": "customer",
      "name": "stripe_customer",
      "macro": "belongs_to",
      "resource_name": "StripeCustomer",
      "through": null
    },
    {
      "className": "StripePaymentMethod",
      "collectionName": "stripe_payment_methods",
      "foreignKey": "payment_method",
      "name": "stripe_payment_method",
      "macro": "belongs_to",
      "resource_name": "StripePaymentMethod",
      "through": null
    }
  ],
  "paramKey": "stripe_payment_intent",
  "primaryKey": "id"
}

/** Frontend model for StripePaymentIntent. */
export default class StripePaymentIntent extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nextActionRedirectToUrl() {
    return this.readAttributeUnderscore("next_action_redirect_to_url")
  }

  /** @returns {boolean} */
  hasNextActionRedirectToUrl() {
    const value = this.nextActionRedirectToUrl()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  status() {
    return this.readAttributeUnderscore("status")
  }

  /** @returns {boolean} */
  hasStatus() {
    const value = this.status()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {import("./stripe-customer.js").default | null} */
  stripeCustomer() {
    return this._readBelongsToReflection({modelClass: StripeCustomer, reflectionName: "stripe_customer"})
  }

  /** @returns {Promise<import("./stripe-customer.js").default | null>} */
  loadStripeCustomer() {
    if (!("customer" in this)) throw new Error("Foreign key method wasn't defined: customer")

    const id = this.customer()
    const ransack = {}

    ransack["stripe_id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "stripe_customer",
        model: this,
        modelClass: StripeCustomer
      },
      {ransack}
    )
  }

  /** @returns {import("./stripe-payment-method.js").default | null} */
  stripePaymentMethod() {
    return this._readBelongsToReflection({modelClass: StripePaymentMethod, reflectionName: "stripe_payment_method"})
  }

  /** @returns {Promise<import("./stripe-payment-method.js").default | null>} */
  loadStripePaymentMethod() {
    if (!("paymentMethod" in this)) throw new Error("Foreign key method wasn't defined: paymentMethod")

    const id = this.paymentMethod()
    const ransack = {}

    ransack["stripe_id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "stripe_payment_method",
        model: this,
        modelClass: StripePaymentMethod
      },
      {ransack}
    )
  }
}
